import { render, staticRenderFns } from "./receiveGoods.vue?vue&type=template&id=5e5609e0&scoped=true"
import script from "./receiveGoods.vue?vue&type=script&lang=js"
export * from "./receiveGoods.vue?vue&type=script&lang=js"
import style0 from "./receiveGoods.vue?vue&type=style&index=0&id=5e5609e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5609e0",
  null
  
)

export default component.exports